import React from 'react';
import Checkbox from 'rc-checkbox';

import 'rc-checkbox/assets/index.css';
import './checkbox.scss';

function CheckboxComponent(props) {
    return <Checkbox {...props} />
}

export default CheckboxComponent;
